import React, { useEffect, useState } from "react";
import { useAdminContext } from "../hooks/UseAdminContext";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { _init_without_token_api } from "../DAL/Login/Login";
import { CircularProgress } from "@mui/material";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const Maintenance = () => {
  const { adminSetting, setAdminSetting } = useAdminContext();
  const classes = useStyles();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const get_setting_data = async () => {
    setIsLoading(true);
    const result = await _init_without_token_api();
    if (result.code == 200) {
      setIsLoading(false);
      setAdminSetting(result?.maintenance_settings);
      if (result?.maintenance_settings?.enable_maintenace_mode) {
        navigate("/under-maintenance", { replace: true });
      } else {
        if (localStorage.getItem("code-verified")) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/login", { replace: true });
        }
      }
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (!adminSetting || Object.keys(adminSetting).length === 0) {
      get_setting_data();
    }
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div className="container text-center">
        <div className="row">
          <div
            className="col-12"
            dangerouslySetInnerHTML={{
              __html: adminSetting?.maintenance_page_content,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
